import React from "react";
import { useNavigate } from "react-router-dom";

/**
 * PaperSubmissionStepper Component
 * 
 * Provides navigation controls for the paper submission multi-step form.
 * Handles previous/next navigation and final submission with loading states.
 * On the first section, shows an "Exit" button that redirects to home page.
 * 
 * @param {Object} props - Component props
 * @param {number} props.currentSection - Current section number (1-5)
 * @param {Function} props.prevSection - Handler to go to previous section
 * @param {Function} props.nextSection - Handler to go to next section
 * @param {Function} props.handleSubmit - Handler for final form submission
 * @param {boolean} props.loading - Loading state for submission
 * @param {boolean} props.navigationLoading - Loading state for navigation
 */
const PaperSubmissionStepper = ({ 
  currentSection, 
  prevSection, 
  nextSection, 
  handleSubmit, 
  loading,
  navigationLoading 
}) => {
  const navigate = useNavigate();

  const handleExit = () => {
    const confirmExit = window.confirm(
      "Are you sure you want to exit?\n\nAll your progress will be lost and you'll be redirected to the home page."
    );
    
    if (confirmExit) {
      navigate('/');
    }
  };

  return (
    <div className="d-flex justify-content-between mt-4">
      {/* Previous/Exit Button */}
      {currentSection === 1 ? (
        <button
          type="button"
          className="btn btn-outline-danger"
          onClick={handleExit}
        >
          <i className="bi bi-x-circle me-2"></i>
          Exit
        </button>
      ) : (
        <button
          type="button"
          className="btn btn-outline-secondary"
          onClick={prevSection}
        >
          <i className="bi bi-arrow-left me-2"></i>
          Previous
        </button>
      )}

      {/* Next or Submit Button */}
      {currentSection < 5 ? (
        <button
          type="button"
          className="btn btn-primary"
          onClick={nextSection}
          disabled={navigationLoading}
        >
          {navigationLoading ? (
            <>
              <span 
                className="spinner-border spinner-border-sm me-2" 
                role="status" 
                aria-hidden="true"
              ></span>
              Loading...
            </>
          ) : (
            <>
              Next
              <i className="bi bi-arrow-right ms-2"></i>
            </>
          )}
        </button>
      ) : (
        <button
          type="submit"
          className="btn btn-success"
          disabled={loading}
        >
          {loading ? (
            <>
              <span 
                className="spinner-border spinner-border-sm me-2" 
                role="status" 
                aria-hidden="true"
              ></span>
              Submitting...
            </>
          ) : (
            <>
              <i className="bi bi-check-circle me-2"></i>
              Submit Manuscript
            </>
          )}
        </button>
      )}
    </div>
  );
};

export default PaperSubmissionStepper;
